const BunInTheOvenLight = () => (
  <svg
    fill="none"
    height="22"
    viewBox="0 0 24 22"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.51841 4.51172H20.3393C22.06 4.51172 23.4578 5.83161 23.4578 7.45647V18.4921C23.4578 19.8025 22.3325 20.8651 20.9449 20.8651H3.09202C1.70436 20.8651 0.579102 19.8025 0.579102 18.4921V7.28731C0.579102 5.75537 1.89611 4.51172 3.51841 4.51172Z"
      fill="url(#paint0_linear_253_19535)"
    />
    <path
      d="M14.8744 12.6417C16.114 13.355 16.9214 14.4439 16.9214 15.3703C16.9214 15.9008 16.6578 16.3323 16.1994 16.6648C15.3374 17.2994 13.7891 17.5938 12.0176 17.5938C10.2461 17.5938 8.70014 17.2994 7.83812 16.6648C7.3798 16.3298 7.11621 15.8983 7.11621 15.3703C7.11621 14.2307 8.33206 12.8499 10.0727 12.2179C10.588 12.0275 11.1508 11.9082 11.7398 11.8803C11.8324 11.8752 11.925 11.8701 12.0176 11.8701C12.5448 11.8701 13.053 11.9437 13.5255 12.0783C14.0123 12.2102 14.4659 12.4031 14.872 12.6392L14.8744 12.6417Z"
      fill="url(#paint1_linear_253_19535)"
    />
    <path
      d="M10.3433 12.3778L9.7639 14.0962C9.61429 14.5378 9.7639 15.0709 10.0821 15.2206C10.1391 15.2485 10.1937 15.2612 10.2507 15.2612C10.4288 15.2612 10.5998 15.1318 10.7019 14.9059L12.008 12.0479L10.3433 12.3778Z"
      fill="#FFD43E"
    />
    <path
      d="M13.4092 12.3496L12.8298 14.0654C12.6802 14.5071 12.8298 15.0401 13.148 15.1924C13.205 15.2203 13.2596 15.233 13.3166 15.233C13.4924 15.233 13.6657 15.1036 13.7654 14.8777L14.7533 12.8217L13.4069 12.3496H13.4092Z"
      fill="#FFD43E"
    />
    <path
      d="M2.64106 1.24121H21.2175C21.5537 1.24121 21.8242 1.5329 21.8242 1.8894V4.51188H2.21387V1.69765C2.21387 1.44647 2.40598 1.24121 2.64106 1.24121Z"
      fill="url(#paint2_linear_253_19535)"
    />
    <path
      d="M21.0136 16.2539H17.0356C16.9253 16.5703 16.6974 16.8426 16.3591 17.0707C15.4621 17.674 13.8518 17.961 12.0062 17.961C10.1606 17.961 8.55032 17.6814 7.65326 17.0707C7.31503 16.8426 7.08709 16.5703 6.97679 16.2539H2.99885C2.68267 16.2539 2.41797 16.5114 2.41797 16.8205V17.9978C2.41797 18.6306 2.94738 19.153 3.59444 19.153H19.5871C20.6974 19.153 21.6018 18.27 21.6018 17.1737V16.8205C21.6018 16.5041 21.3444 16.2539 21.0209 16.2539H21.0136Z"
      fill="#56BB6C"
    />
    <path
      d="M22.3162 4.44394V1.54485C22.3162 0.970918 21.8382 0.5 21.2574 0.5H2.75C2.16176 0.5 1.69118 0.970918 1.69118 1.54485V4.4513C0.661765 5.03259 0 6.12894 0 7.29888V18.2036C0 20.021 1.50735 21.5 3.35294 21.5H20.6471C22.5 21.5 24 20.021 24 18.2036V7.29888C24 6.10687 23.3382 5.02523 22.3088 4.44394H22.3162ZM2.42647 1.54485C2.42647 1.37561 2.57353 1.23581 2.75 1.23581H21.2574C21.4338 1.23581 21.5809 1.37561 21.5809 1.54485V4.14226C21.2721 4.05396 20.9632 3.99509 20.6471 3.99509H3.36029C3.04412 3.99509 2.72794 4.05396 2.42647 4.14226V1.54485ZM23.2647 18.2036C23.2647 19.6163 22.0882 20.7642 20.6471 20.7642H3.35294C1.90441 20.7642 0.735294 19.6163 0.735294 18.2036V7.29888C0.735294 6.32025 1.31618 5.41521 2.22059 4.98844C2.58088 4.8192 2.96324 4.7309 3.35294 4.7309H20.6471C20.9485 4.7309 21.25 4.78241 21.5441 4.89278C22.5735 5.26069 23.2647 6.2246 23.2647 7.29888V18.2036Z"
      fill="#6E3264"
    />
    <path
      d="M3.43951 8.59949C4.11641 8.59949 4.66515 8.05036 4.66515 7.37299C4.66515 6.69561 4.11641 6.14648 3.43951 6.14648C2.76261 6.14648 2.21387 6.69561 2.21387 7.37299C2.21387 8.05036 2.76261 8.59949 3.43951 8.59949Z"
      fill="url(#paint3_linear_253_19535)"
    />
    <path
      d="M7.52447 8.59949C8.20137 8.59949 8.75011 8.05036 8.75011 7.37299C8.75011 6.69561 8.20137 6.14648 7.52447 6.14648C6.84757 6.14648 6.29883 6.69561 6.29883 7.37299C6.29883 8.05036 6.84757 8.59949 7.52447 8.59949Z"
      fill="url(#paint4_linear_253_19535)"
    />
    <path
      d="M16.5128 8.59949C17.1897 8.59949 17.7384 8.05036 17.7384 7.37299C17.7384 6.69561 17.1897 6.14648 16.5128 6.14648C15.8358 6.14648 15.2871 6.69561 15.2871 7.37299C15.2871 8.05036 15.8358 8.59949 16.5128 8.59949Z"
      fill="url(#paint5_linear_253_19535)"
    />
    <path
      d="M20.5982 8.59949C21.2751 8.59949 21.8238 8.05036 21.8238 7.37299C21.8238 6.69561 21.2751 6.14648 20.5982 6.14648C19.9213 6.14648 19.3726 6.69561 19.3726 7.37299C19.3726 8.05036 19.9213 8.59949 20.5982 8.59949Z"
      fill="url(#paint6_linear_253_19535)"
    />
    <path
      d="M3.68377 8.68199C4.53671 8.68199 5.22788 7.99769 5.22788 7.15887C5.22788 6.32005 4.53671 5.63574 3.68377 5.63574C2.83083 5.63574 2.13965 6.32005 2.13965 7.15887C2.13965 7.99769 2.83083 8.68199 3.68377 8.68199ZM3.68377 6.37155C4.1323 6.37155 4.49259 6.72474 4.49259 7.15887C4.49259 7.593 4.12494 7.94618 3.68377 7.94618C3.24259 7.94618 2.87494 7.593 2.87494 7.15887C2.87494 6.72474 3.24259 6.37155 3.68377 6.37155Z"
      fill="#6E3264"
    />
    <path
      d="M7.44841 8.68199C8.30136 8.68199 8.99253 7.99769 8.99253 7.15887C8.99253 6.32005 8.30136 5.63574 7.44841 5.63574C6.59547 5.63574 5.9043 6.32005 5.9043 7.15887C5.9043 7.99769 6.59547 8.68199 7.44841 8.68199ZM7.44841 6.37155C7.89694 6.37155 8.25724 6.72474 8.25724 7.15887C8.25724 7.593 7.88959 7.94618 7.44841 7.94618C7.00724 7.94618 6.63959 7.593 6.63959 7.15887C6.63959 6.72474 7.00724 6.37155 7.44841 6.37155Z"
      fill="#6E3264"
    />
    <path
      d="M16.5588 8.7333C17.4117 8.7333 18.1029 8.04899 18.1029 7.20281C18.1029 6.35663 17.4117 5.67969 16.5588 5.67969C15.7058 5.67969 15.0146 6.36399 15.0146 7.20281C15.0146 8.04164 15.7058 8.7333 16.5588 8.7333ZM16.5588 6.4155C17.0073 6.4155 17.3676 6.76869 17.3676 7.20281C17.3676 7.63694 16.9999 7.99749 16.5588 7.99749C16.1176 7.99749 15.7499 7.6443 15.7499 7.20281C15.7499 6.76133 16.1102 6.4155 16.5588 6.4155Z"
      fill="#6E3264"
    />
    <path
      d="M20.3234 8.7333C21.1764 8.7333 21.8675 8.04899 21.8675 7.20281C21.8675 6.35663 21.1764 5.67969 20.3234 5.67969C19.4705 5.67969 18.7793 6.36399 18.7793 7.20281C18.7793 8.04164 19.4705 8.7333 20.3234 8.7333ZM20.3234 6.4155C20.7719 6.4155 21.1322 6.76869 21.1322 7.20281C21.1322 7.63694 20.7646 7.99749 20.3234 7.99749C19.8822 7.99749 19.5146 7.6443 19.5146 7.20281C19.5146 6.76133 19.8749 6.4155 20.3234 6.4155Z"
      fill="#6E3264"
    />
    <path
      d="M20.125 9.60938H3.87497C2.84556 9.60938 2.00732 10.4335 2.00732 11.4415V17.6297C2.00732 18.6451 2.84556 19.4692 3.87497 19.4692H20.125C21.1544 19.4692 21.9926 18.6451 21.9926 17.6297V11.4415C21.9926 10.4335 21.1544 9.60938 20.125 9.60938ZM3.87497 10.3452H20.125C20.75 10.3452 21.2573 10.8382 21.2573 11.4415V16.0551H17.4264C17.4853 15.8858 17.5147 15.7019 17.5147 15.5179C17.5147 14.4951 16.625 13.3546 15.2426 12.6041L15.1764 12.5673C14.7059 12.3172 14.2059 12.1258 13.6838 12.0008C13.1397 11.861 12.5735 11.7874 12.0073 11.7874C11.9117 11.7874 11.8235 11.7874 11.6985 11.7947C11.0661 11.8242 10.4485 11.9345 9.85291 12.1406C7.91174 12.7954 6.49997 14.2155 6.49997 15.5253C6.49997 15.7092 6.53674 15.8932 6.59556 16.0624H2.74262V11.4489C2.74262 10.8455 3.24997 10.3525 3.87497 10.3525V10.3452ZM9.55879 15.5694C9.63968 15.5989 9.74262 15.6283 9.86762 15.6283C10.1985 15.6283 10.4926 15.4223 10.6691 15.0838L11.9485 12.5158C11.9485 12.5158 11.9853 12.5158 12 12.5158C12.3823 12.5158 12.7573 12.5673 13.125 12.6336L12.6029 14.0537C12.3823 14.6644 12.625 15.3781 13.1323 15.5989C13.2353 15.643 13.3456 15.6724 13.4632 15.6724C13.7941 15.6724 14.1029 15.4591 14.2573 15.1353L15.1617 13.4135C16.1397 14.0169 16.7794 14.8336 16.7794 15.5179C16.7794 15.746 16.7059 15.9447 16.5514 16.136C16.4559 16.2464 16.3382 16.3567 16.1764 16.4598C15.3823 16.9969 13.897 17.2912 11.9926 17.2912C10.0882 17.2912 8.61027 16.9969 7.81615 16.4598C7.6985 16.3788 7.58821 16.2832 7.49262 16.1875C7.49262 16.1802 7.47791 16.1654 7.47056 16.1581C7.30144 15.9594 7.22056 15.746 7.22056 15.5106C7.22056 14.7895 7.99997 13.7888 9.3235 13.1339L8.99997 14.0022C8.77203 14.6129 9.00732 15.3266 9.55144 15.5621L9.55879 15.5694ZM9.6985 14.267L10.2426 12.7881C10.5147 12.7071 10.7941 12.6409 11.0809 12.5968L10.0073 14.7527C9.95585 14.8483 9.90438 14.8925 9.83085 14.8851C9.70585 14.8336 9.59556 14.5319 9.6985 14.267ZM13.2941 14.3112L13.8456 12.8175C14.0735 12.8911 14.2941 12.972 14.5147 13.075L13.6029 14.8115C13.5588 14.9072 13.4926 14.9514 13.4411 14.9366C13.3161 14.8851 13.1985 14.5908 13.3014 14.3112H13.2941ZM20.125 18.7334H3.87497C3.24997 18.7334 2.74262 18.2404 2.74262 17.6297V16.7909H7.08821C7.19115 16.8865 7.29409 16.9895 7.41174 17.0705C8.3235 17.6886 9.95585 18.027 12 18.027C14.0441 18.027 15.6764 17.6886 16.5882 17.0705C16.7206 16.9822 16.8309 16.8865 16.9338 16.7909H21.2573V17.6297C21.2573 18.2404 20.75 18.7334 20.125 18.7334Z"
      fill="#6E3264"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_253_19535"
        x1="12.0184"
        x2="12.0184"
        y1="14.7552"
        y2="4.51172"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="1" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_253_19535"
        x1="12.0188"
        x2="12.0188"
        y1="17.5938"
        y2="11.3697"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_253_19535"
        x1="12.019"
        x2="12.019"
        y1="4.51192"
        y2="1.24121"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_253_19535"
        x1="3.4395"
        x2="3.4395"
        y1="8.59951"
        y2="6.14648"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_253_19535"
        x1="7.52447"
        x2="7.52447"
        y1="8.59951"
        y2="6.14648"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_253_19535"
        x1="16.5127"
        x2="16.5127"
        y1="8.59951"
        y2="6.14648"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_253_19535"
        x1="20.5982"
        x2="20.5982"
        y1="8.59951"
        y2="6.14648"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="0.7359" stopColor="#56BB6C" />
      </linearGradient>
    </defs>
  </svg>
)

export default BunInTheOvenLight
